import { ref, watch } from 'vue'
import type { WatchSource } from 'vue'

export function useLazyRender(show: WatchSource<boolean | undefined>) {
  const inited = ref(false)

  watch(
    show,
    (value) => {
      if (value) {
        inited.value = value
      }
    },
    { immediate: true }
  )

  return (render: () => JSX.Element | undefined) => () =>
    inited.value ? render() : null
}
